import { useState } from 'react';
import { Button, Input, Modal, Typography, message } from 'antd';

type Props = {
  subscription: { status: string; currentPeriodEnd?: string | null; trialEnd?: string | null };
  onSave: (expiresAt: string | null) => Promise<unknown>;
  onUpdated: () => Promise<void>;
};

export default function AdminAccessExpiry({ subscription, onSave, onUpdated }: Props) {
  const [open, setOpen] = useState(false);
  const [expiry, setExpiry] = useState('');
  const [saving, setSaving] = useState(false);
  const edit = () => {
    const end = subscription.trialEnd || subscription.currentPeriodEnd;
    const date = end ? new Date(end) : null;
    setExpiry(date ? new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16) : '');
    setOpen(true);
  };
  const save = async () => {
    if (subscription.status === 'TRIAL' && !expiry) { message.error('Trials must have an expiry date'); return; }
    const date = expiry ? new Date(expiry) : null;
    if (date && (Number.isNaN(date.getTime()) || date.getTime() <= Date.now())) { message.error('Choose a future expiry date'); return; }
    try {
      setSaving(true);
      await onSave(date?.toISOString() ?? null);
      setOpen(false);
      message.success('Access expiry updated');
      await onUpdated();
    } catch (error: any) { message.error(error.message || 'Failed to update access'); }
    finally { setSaving(false); }
  };
  return <>
    <Button size="small" onClick={edit}>Change Expiry</Button>
    <Modal title="Change access expiry" open={open} onCancel={() => setOpen(false)} onOk={save} confirmLoading={saving}>
      <Input type="datetime-local" value={expiry} onChange={(event) => setExpiry(event.target.value)} />
      <Typography.Text type="secondary">{subscription.status === 'TRIAL' ? 'Choose when this trial ends.' : 'Leave empty for access without an expiry date.'}</Typography.Text>
    </Modal>
  </>;
}
